package com.klantenstop.web.pages.company

import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.collectAsState
import androidx.compose.runtime.getValue
import com.klantenstop.web.components.ClusteredMap
import com.klantenstop.web.components.Dialog
import com.klantenstop.web.components.KsCompanyLogo
import com.klantenstop.web.components.KsExternalLink
import com.klantenstop.web.components.KsReviewStars
import com.klantenstop.web.components.KsStatusUpdatedAt
import com.klantenstop.web.components.KsVerified
import com.klantenstop.web.components.StatusIconSize
import com.klantenstop.web.components.H1Heading
import com.klantenstop.web.components.H2Heading
import com.klantenstop.web.components.dialogs.LoginRequiredDialog
import com.klantenstop.web.components.dialogs.manageCompanyReview.ManageCompanyReviewDialog
import com.klantenstop.web.components.layout.PageLayout
import com.klantenstop.web.components.layout.PageSeoConfig
import com.klantenstop.web.components.search.SearchSection
import com.klantenstop.web.components.toColor
import com.klantenstop.web.data.models.domain.Company
import com.klantenstop.web.data.models.domain.Review
import com.klantenstop.web.data.models.domain.ReviewTotal
import com.klantenstop.web.data.models.domain.Status
import com.klantenstop.web.navigation.Navigation
import com.klantenstop.web.pages.manageCompany.components.GuidanceCard
import com.klantenstop.web.styles.Typography
import com.materialkobweb.styles.MaterialColorVars
import com.klantenstop.web.utils.Constants
import com.klantenstop.web.utils.UpdateCompanySeo
import com.materialkobweb.utils.rememberViewModel
import com.klantenstop.web.components.CustomSelect
import com.klantenstop.web.utils.maxLines
import com.materialkobweb.components.widgets.DsCard
import com.materialkobweb.components.widgets.DsEditableArea
import com.materialkobweb.components.widgets.DsMaterialSymbols
import com.materialkobweb.components.widgets.FilledButton
import com.materialkobweb.components.widgets.IconButton
import com.materialkobweb.components.widgets.OutlinedButton
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.css.OverflowWrap
import com.varabyte.kobweb.compose.css.TextAlign
import com.varabyte.kobweb.compose.css.WhiteSpace
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.alignContent
import com.varabyte.kobweb.compose.ui.modifiers.alignItems
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.borderRadius
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.columnGap
import com.varabyte.kobweb.compose.ui.modifiers.display
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxSize
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.flexDirection
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.fontWeight
import com.varabyte.kobweb.compose.ui.modifiers.gap
import com.varabyte.kobweb.compose.ui.modifiers.lineHeight
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.marginBlock
import com.varabyte.kobweb.compose.ui.modifiers.maxHeight
import com.varabyte.kobweb.compose.ui.modifiers.maxWidth
import com.varabyte.kobweb.compose.ui.modifiers.minHeight
import com.varabyte.kobweb.compose.ui.modifiers.overflowWrap
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.modifiers.size
import com.varabyte.kobweb.compose.ui.modifiers.textAlign
import com.varabyte.kobweb.compose.ui.modifiers.whiteSpace
import com.varabyte.kobweb.compose.ui.thenIf
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.PageContext
import com.varabyte.kobweb.navigation.UpdateHistoryMode
import com.varabyte.kobweb.silk.components.forms.ButtonSize
import com.varabyte.kobweb.silk.components.layout.SimpleGrid
import com.varabyte.kobweb.silk.components.layout.numColumns
import com.varabyte.kobweb.silk.components.navigation.AlwaysUnderlinedLinkVariant
import com.varabyte.kobweb.silk.components.navigation.Link
import com.varabyte.kobweb.silk.components.navigation.LinkStyle
import com.varabyte.kobweb.silk.components.text.SpanText
import com.varabyte.kobweb.silk.style.breakpoint.Breakpoint
import com.varabyte.kobweb.silk.style.toModifier
import com.varabyte.kobweb.silk.theme.breakpoint.rememberBreakpoint
import kotlinx.coroutines.flow.collectLatest
import org.jetbrains.compose.web.attributes.ButtonType
import org.jetbrains.compose.web.css.AlignContent
import org.jetbrains.compose.web.css.AlignItems
import org.jetbrains.compose.web.css.DisplayStyle
import org.jetbrains.compose.web.css.FlexDirection
import org.jetbrains.compose.web.css.div
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.css.vh
import org.jetbrains.compose.web.dom.CheckboxInput
import org.jetbrains.compose.web.dom.H2
import org.jetbrains.compose.web.dom.Label
import org.jetbrains.compose.web.dom.Text

@Page("/bedrijf/{companyIdentifier}")
@Composable
fun CompanyPage(ctx: PageContext) {
    val companyIdentifier = ctx.route.params.getValue("companyIdentifier")

    // Use companyIdentifier as key to maintain ViewModel across navigation
    // rememberViewModel uses a global store to persist ViewModels across back/forward navigation
    val viewModel = rememberViewModel { CompanyViewModel(companyIdentifier) }
    val state by viewModel.state.collectAsState()

    LaunchedEffect(Unit) {
        viewModel.effect.collectLatest {
            when (it) {
                else -> Unit
            }
        }
    }

    LaunchedEffect(state.company?.slug, state.companyIdentifier) {
        val slug = state.company?.slug
        if (!slug.isNullOrBlank() && slug != state.companyIdentifier) {
            ctx.router.navigateTo(
                pathQueryAndFragment = Navigation.Screen.CompanyDetail(slug).route,
                updateHistoryMode = UpdateHistoryMode.REPLACE
            )
        }
    }

    CompanyContent(state, viewModel::sendIntent)
}

@Composable
private fun CompanyContent(
    state: CompanyContract.State,
    sendIntent: (CompanyContract.Intent) -> Unit
) {
    val breakpoint = rememberBreakpoint()

    UpdateCompanySeo(
        company = state.company,
        reviewTotal = state.reviewTotal,
        companyIdentifier = state.companyIdentifier,
        isNotFound = state.companyNotFound,
    )

    PageLayout(
        modifier = Modifier.fillMaxSize(),
        title = state.company?.name ?: "",
        seo = PageSeoConfig.External,
    ) {
        // Show "not found" state when company doesn't exist
        if (state.companyNotFound) {
            CompanyNotFoundState()
            return@PageLayout
        }

        Column(
            modifier = Modifier.fillMaxSize(),
            horizontalAlignment = Alignment.CenterHorizontally
        ) {
            if (!state.loading) {
                SearchSection(
                    categories = state.categories,
                    horizontal = breakpoint >= Breakpoint.SM,
                    collapsible = breakpoint < Breakpoint.SM,
                    modifier = Modifier.fillMaxWidth(if (breakpoint == Breakpoint.SM) 90.percent else 80.percent)
                        .margin(top = 32.px)
                        .maxWidth(Constants.SECTION_WIDTH.px.div(1.5)),
                )
            }

            SimpleGrid(
                modifier = Modifier
                    .fillMaxWidth()
                    .margin(top = 100.px)
                    .maxWidth(Constants.SECTION_WIDTH_2.px),
                numColumns = numColumns(1, lg = 2)
            ) {
                Box(
                    modifier = Modifier.fillMaxWidth().minHeight(40.vh).maxHeight(60.vh).backgroundColor(MaterialColorVars.SurfaceContainer.value())
                ) {
                    val coordinates = state.company?.address?.coordinates

                    if (coordinates != null) {
                        ClusteredMap(
                            lat = coordinates.latitude,
                            lng = coordinates.longitude,
                            label = state.company.name,
                            iconUrl = state.company.status.status.toPinIconUrl()
                        )
                    }
                }

                if (state.company != null) {
                    CompanyDetails(
                        company = state.company,
                        sendIntent = sendIntent,
                        modifier = Modifier.fillMaxWidth()
                            .padding(leftRight = if (breakpoint >= Breakpoint.MD) 50.px else 24.px, topBottom = 32.px)
                    )
                }
            }

            ReviewHeader(
                modifier = Modifier.fillMaxWidth(if (breakpoint >= Breakpoint.MD) 80.percent else 90.percent)
                    .maxWidth(Constants.SECTION_WIDTH.px)
                    .margin(top = 100.px, bottom = 32.px),
                userHasReview = state.userHasReview,
                reviewTotal = state.reviewTotal,
                sendIntent = sendIntent
            )

            Column(
                modifier = Modifier
                    .fillMaxWidth(if (breakpoint >= Breakpoint.MD) 80.percent else 90.percent)
                    .maxWidth(Constants.SECTION_WIDTH.px),
                verticalArrangement = Arrangement.spacedBy(32.px)
            ) {
                if (state.myReview != null) {
                    ReviewCard(
                        modifier = Modifier.margin(bottom = 56.px),
                        review = state.myReview
                    )
                }

                // Skip user's own review from the public list to prevent duplication
                state.reviews
                    .filter { it.id != state.myReview?.id }
                    .forEach { review ->
                        ReviewCard(review = review)
                    }
            }
        }

        if (state.showUpdateCompanyStatusDialog) {
            UpdateCompanyStatusDialog(state, sendIntent)
        }

        if (state.showCreateCompanyReviewDialog) {
            ManageCompanyReviewDialog(
                currentUserReview = state.myReview,
                isSaving = state.isSavingReview,
                onHideDialog = { sendIntent(CompanyContract.Intent.HideCreateCompanyReviewDialog) },
                onSaveReview = { rating, reviewText ->
                    sendIntent(
                        CompanyContract.Intent.SaveCompanyReview(
                            rating = rating,
                            reviewText = reviewText,
                        )
                    )
                }
            )
        }

        if (state.showLoginRequiredDialog) {
            LoginRequiredDialog(
                onHideDialog = { sendIntent(CompanyContract.Intent.HideLoginRequiredDialog) }
            )
        }
    }
}

@Composable
private fun UpdateCompanyStatusDialog(
    state: CompanyContract.State,
    sendIntent: (CompanyContract.Intent) -> Unit
) {
    Dialog(
        onHideDialog = {
            sendIntent(CompanyContract.Intent.HideUpdateCompanyStatusDialog)
        }
    ) {
        Row(
            modifier = Modifier.fillMaxWidth(),
            horizontalArrangement = Arrangement.SpaceBetween
        ) {
            H2(
                attrs = Modifier.marginBlock(0.px).toAttrs()
            ) {
                Text("Update bedrijfsstatus")
            }

            IconButton(
                modifier = Modifier,
                size = ButtonSize.SM,
                type = ButtonType.Button,
                enabled = true,
                onClick = { sendIntent(CompanyContract.Intent.HideUpdateCompanyStatusDialog) },
                content = {
                    DsMaterialSymbols(
                        icon = "close",
                        modifier = Modifier.fontSize(20.px)
                    )
                }
            )
        }

        CustomSelect(
            modifier = Modifier.fillMaxWidth()
                .padding(top = 36.px, bottom = 8.px),
            id = "dropdown-company-status",
            label = "Status",
            placeholder = "",
            items = Status.Type.entries.map { it.toText() },
            selectedItem = state.selectedStatusType.toText(),
            onItemSelect = { _, item ->
                sendIntent(CompanyContract.Intent.UpdateCompanyStatus(Status.Type.fromText(item)))
            }
        )

        Row(
            modifier = Modifier.fillMaxWidth().margin(bottom = 12.px),
            verticalAlignment = Alignment.CenterVertically,
            horizontalArrangement = Arrangement.spacedBy(8.px)
        ) {
            CheckboxInput(checked = state.showStatusDescription) {
                id("checkboxStatusDescriptionDialog")
                onChange { sendIntent(CompanyContract.Intent.ToggleStatusDescriptionVisibility) }
            }
            Label(forId = "checkboxStatusDescriptionDialog") {
                Text("Voeg extra beschrijving toe")
            }
        }

        if (state.showStatusDescription) {
            GuidanceCard(
                text = "💡 Tip: Gebruik de statusbeschrijving om extra context te geven over de huidige status van het bedrijf (bijv. \"Tijdelijk gesloten wegens renovatie, heropening gepland voor Q4 2024\")",
                modifier = Modifier.margin(bottom = 12.px)
            )

            DsEditableArea(
                modifier = Modifier.fillMaxWidth(),
                id = "inputStatusDescription",
                label = "Status beschrijving",
                placeholder = "",
                value = state.statusDescription,
                onValueChange = {
                    sendIntent(CompanyContract.Intent.UpdateCompanyStatusDescription(it))
                }
            )
        }

        Row(
            modifier = Modifier
                .fillMaxWidth()
                .padding(top = 36.px),
            horizontalArrangement = Arrangement.End
        ) {
            FilledButton(
                onClick = {
                    sendIntent(CompanyContract.Intent.SaveCompanyStatusUpdate)
                }
            ) {
                Text("Update status")
            }
        }
    }
}

@Composable
private fun CompanyDetails(
    company: Company,
    modifier: Modifier = Modifier,
    sendIntent: (CompanyContract.Intent) -> Unit
) {
    Column(modifier = modifier) {
        Row(
            modifier = Modifier.fillMaxWidth(),
            horizontalArrangement = Arrangement.spacedBy(32.px),
            verticalAlignment = Alignment.CenterVertically
        ) {
            KsCompanyLogo(
                company = company,
                statusIconSize = StatusIconSize.Sm,
                modifier = Modifier.size(70.px)
            )

            Column {
                H1Heading(
                    modifier = Typography.HeadlineSmall.toModifier().maxLines(2).fillMaxWidth(),
                    text = company.name,
                    color = MaterialColorVars.OnSurface.value(),
                )

                Row(
                    horizontalArrangement = Arrangement.spacedBy(16.px)
                ) {
                    if (company.verified) {
                        KsVerified(modifier = Modifier.margin(top = 10.px))
                    }

                    Link(
                        path = Navigation.Screen.ManageCompany(company.id).route,
                        modifier = LinkStyle
                            .toModifier(AlwaysUnderlinedLinkVariant)
                            .margin(top = 4.px)
                            .color(MaterialColorVars.Primary.value())
                    ) {
                        SpanText(
                            modifier = Modifier
                                .fontSize(12.px)
                                .lineHeight(14.px)
                                .fontWeight(FontWeight.Medium),
                            text = "Wijzig gegevens"
                        )
                    }
                }
            }
        }

        // Company Description
        if (company.description.isNotBlank()) {
            SpanText(
                modifier = Modifier.margin(top = 32.px)
                    .fontSize(14.px)
                    .lineHeight(20.px)
                    .overflowWrap(OverflowWrap.BreakWord)
                    .whiteSpace(WhiteSpace.PreLine),
                text = company.description
            )
        }

        Column(
            modifier = Modifier.fillMaxWidth()
                .margin(top = 50.px),
            verticalArrangement = Arrangement.spacedBy(4.px)
        ) {
            val someModifier = Modifier
                .columnGap(12.px)
                .fontSize(14.px)
                .lineHeight(16.px)

            KsExternalLink(
                modifier = someModifier,
                text = company.address?.fullAddress?.ifBlank { "/" } ?: "/",
                href = Navigation.External.Maps(company.address?.fullAddress.orEmpty().replace(" ", "+").replace(",", "")).route,
                materialIcon = "location_on"
            )
            KsExternalLink(
                modifier = someModifier,
                text = company.phoneNumber.ifBlank { "/" },
                href = company.phoneNumber.ifBlank { null }?.let { Navigation.External.Phone(it).route },
                materialIcon = "phone"
            )
            KsExternalLink(
                modifier = someModifier,
                text = company.emailAddress.ifBlank { "/" },
                href = company.emailAddress.ifBlank { null }?.let { Navigation.External.Mail(it).route },
                materialIcon = "mail"
            )
            KsExternalLink(
                modifier = someModifier,
                text = company.website?.href ?: "/",
                href = company.website?.href,
                materialIcon = "globe"
            )
        }

        // Status Section - visually distinct area showing status type and description
        Column(
            modifier = Modifier
                .fillMaxWidth()
                .margin(top = 32.px)
                .padding(16.px)
                .backgroundColor(MaterialColorVars.SurfaceContainerLow.value())
                .borderRadius(8.px),
            verticalArrangement = Arrangement.spacedBy(12.px)
        ) {
            Row(
                verticalAlignment = Alignment.CenterVertically,
                horizontalArrangement = Arrangement.spacedBy(12.px)
            ) {
                // Status Icon
                DsMaterialSymbols(
                    modifier = Modifier.fontSize(24.px),
                    icon = company.status.status.toMaterialIcon(),
                    color = company.status.status.toColor()
                )

                // Status Label
                SpanText(
                    modifier = Modifier
                        .fontSize(16.px)
                        .lineHeight(18.px)
                        .fontWeight(FontWeight.SemiBold),
                    text = "Huidige status: ${company.status.status.toText()}"
                )
            }

            // Status Description
            if (company.status.text.isNotBlank()) {
                SpanText(
                    modifier = Modifier
                        .fontSize(14.px)
                        .lineHeight(20.px)
                        .color(MaterialColorVars.OnSurfaceVariant.value())
                        .overflowWrap(OverflowWrap.BreakWord)
                        .whiteSpace(WhiteSpace.PreLine),
                    text = company.status.text
                )
            }
        }

        Row(
            modifier = Modifier.fillMaxWidth().margin(top = 24.px),
            horizontalArrangement = Arrangement.SpaceBetween,
            verticalAlignment = Alignment.Top
        ) {
            KsStatusUpdatedAt(company)

            OutlinedButton(onClick = {
                sendIntent(CompanyContract.Intent.ShowUpdateCompanyStatusDialog)
            }) {
                Row {
                    DsMaterialSymbols(
                        modifier = Modifier
                            .fontSize(20.px)
                            .margin(right = 8.px),
                        icon = "edit"
                    )

                    Text("Update status")
                }
            }
        }
    }
}

@Composable
private fun ReviewHeader(
    modifier: Modifier = Modifier,
    userHasReview: Boolean = false,
    reviewTotal: ReviewTotal = ReviewTotal(),
    sendIntent: (CompanyContract.Intent) -> Unit
) {
    val breakpoint = rememberBreakpoint()

    Row(
        modifier = modifier,
        horizontalArrangement = Arrangement.SpaceBetween,
        verticalAlignment = Alignment.CenterVertically
    ) {
        Box(
            modifier = Modifier
                .display(DisplayStyle.Flex)
                .flexDirection(FlexDirection.Row)
                .alignItems(AlignItems.Center)
                .gap(8.px)
                .thenIf(breakpoint < Breakpoint.SM) {
                    Modifier.flexDirection(FlexDirection.Column)
                        .alignItems(AlignItems.Start)
                }
        ) {
            H2Heading(
                text = "Reviews",
                color = MaterialColorVars.OnBackground.value()
            )

            Row(
                verticalAlignment = Alignment.CenterVertically
            ) {
                KsReviewStars(
                    average = reviewTotal.average,
                    starSize = 16.px
                )

                SpanText(
                    text = "(${reviewTotal.total})",
                    modifier = Modifier
                        .margin(2.px)
                        .fontSize(12.px)
                        .lineHeight(12.px)
                        .fontWeight(FontWeight.Normal)
                )
            }
        }

        OutlinedButton(
            onClick = {
                sendIntent(CompanyContract.Intent.ShowCreateCompanyReviewDialog)
            }
        ) {
            Text(if (userHasReview) "Update jouw review" else "Schrijf een review")
        }
    }
}

@Composable
private fun ReviewCard(
    modifier: Modifier = Modifier,
    review: Review
) {
    DsCard(
        modifier = modifier.fillMaxWidth(),
        contentPadding = 24.px
    ) {
        Column(
            modifier = Modifier.margin(topBottom = 12.px)
        ) {
            KsReviewStars(review.rating.toDouble(), 26.px)

            SpanText(
                modifier = Modifier.margin(top = 16.px)
                    .fontSize(16.px)
                    .lineHeight(18.px)
                    .overflowWrap(OverflowWrap.BreakWord),
                text = review.text
            )

            Row(
                modifier = Modifier.margin(top = 32.px),
                horizontalArrangement = Arrangement.spacedBy(12.px),
                verticalAlignment = Alignment.Bottom
            ) {
                SpanText(
                    modifier = Modifier
                        .fontSize(20.px)
                        .lineHeight(22.px)
                        .fontWeight(FontWeight.Medium),
                    text = review.user?.let { "${it.firstName} ${it.lastName}" } ?: "Anoniem"
                )

                SpanText(
                    modifier = Modifier
                        .fontSize(12.px)
                        .lineHeight(14.px)
                        .color(MaterialColorVars.Outline.value()),
                    text = review.createdAtHumanReadable
                )
            }
        }
    }
}

@Composable
private fun CompanyNotFoundState() {
    val breakpoint = rememberBreakpoint()
    val ctx = com.varabyte.kobweb.core.rememberPageContext()
    val isMobile = breakpoint < Breakpoint.MD

    Column(
        modifier = Modifier
            .fillMaxSize()
            .padding(topBottom = if (isMobile) 60.px else 120.px, leftRight = 24.px),
        horizontalAlignment = Alignment.CenterHorizontally
    ) {
        DsCard(
            modifier = Modifier
                .fillMaxWidth(if (isMobile) 100.percent else 70.percent)
                .maxWidth(700.px),
            contentPadding = if (isMobile) 32.px else 48.px
        ) {
            Column(
                modifier = Modifier.fillMaxWidth(),
                horizontalAlignment = Alignment.CenterHorizontally,
                verticalArrangement = Arrangement.spacedBy(if (isMobile) 24.px else 32.px)
            ) {
                // Icon with background
                Box(
                    modifier = Modifier
                        .size(if (isMobile) 96.px else 120.px)
                        .backgroundColor(MaterialColorVars.ErrorContainer.value())
                        .borderRadius(60.px),
                    contentAlignment = Alignment.Center
                ) {
                    DsMaterialSymbols(
                        icon = "store",
                        modifier = Modifier
                            .fontSize(if (isMobile) 56.px else 72.px)
                            .alignContent(AlignContent.Center)
                            .textAlign(TextAlign.Center)
                            .color(MaterialColorVars.OnErrorContainer.value())
                    )
                }

                // Title and Description
                Column(
                    modifier = Modifier.fillMaxWidth(),
                    horizontalAlignment = Alignment.CenterHorizontally,
                    verticalArrangement = Arrangement.spacedBy(12.px)
                ) {
                    H1Heading(
                        typography = Typography.HeadlineSmall,
                        text = "Bedrijf niet gevonden",
                        color = MaterialColorVars.OnSurface.value()
                    )

                    SpanText(
                        modifier = Modifier
                            .color(MaterialColorVars.OnSurfaceVariant.value())
                            .fontSize(if (isMobile) 14.px else 16.px)
                            .lineHeight(if (isMobile) 21.px else 24.px)
                            .whiteSpace(WhiteSpace.PreWrap)
                            .fillMaxWidth(if (isMobile) 100.percent else 85.percent),
                        text = "Het bedrijf dat u zoekt bestaat niet of is verwijderd uit ons systeem. Mogelijk is het bedrijf recent verwijderd of heeft u een ongeldige link gebruikt."
                    )
                }

                // Divider
                Box(
                    modifier = Modifier
                        .fillMaxWidth(90.percent)
                        .margin(topBottom = 8.px)
                        .minHeight(1.px)
                        .backgroundColor(MaterialColorVars.OutlineVariant.value())
                )

                // Helpful suggestions section
                Column(
                    modifier = Modifier
                        .fillMaxWidth()
                        .padding(leftRight = if (isMobile) 0.px else 16.px),
                    verticalArrangement = Arrangement.spacedBy(16.px)
                ) {
                    SpanText(
                        modifier = Modifier
                            .fontSize(14.px)
                            .lineHeight(20.px)
                            .fontWeight(FontWeight.SemiBold)
                            .color(MaterialColorVars.OnSurface.value()),
                        text = "Wat kunt u doen?"
                    )

                    // Suggestion 1
                    Row(
                        modifier = Modifier.fillMaxWidth(),
                        horizontalArrangement = Arrangement.spacedBy(12.px),
                        verticalAlignment = Alignment.Top
                    ) {
                        DsMaterialSymbols(
                            icon = "search",
                            modifier = Modifier
                                .size(20.px)
                                .margin(top = 2.px)
                                .color(MaterialColorVars.Primary.value())
                        )
                        SpanText(
                            modifier = Modifier
                                .fontSize(13.px)
                                .lineHeight(19.px)
                                .color(MaterialColorVars.OnSurfaceVariant.value()),
                            text = "Zoek naar het bedrijf via de zoekpagina met andere trefwoorden"
                        )
                    }

                    // Suggestion 2
                    Row(
                        modifier = Modifier.fillMaxWidth(),
                        horizontalArrangement = Arrangement.spacedBy(12.px),
                        verticalAlignment = Alignment.Top
                    ) {
                        DsMaterialSymbols(
                            icon = "add_business",
                            modifier = Modifier
                                .size(20.px)
                                .margin(top = 2.px)
                                .color(MaterialColorVars.Primary.value())
                        )
                        SpanText(
                            modifier = Modifier
                                .fontSize(13.px)
                                .lineHeight(19.px)
                                .color(MaterialColorVars.OnSurfaceVariant.value()),
                            text = "Voeg het bedrijf toe aan ons platform als het nog niet bestaat"
                        )
                    }
                }

                // Action buttons - responsive layout
                if (isMobile) {
                    // Stack buttons vertically on mobile
                    Column(
                        modifier = Modifier
                            .fillMaxWidth()
                            .margin(top = 8.px),
                        verticalArrangement = Arrangement.spacedBy(12.px)
                    ) {
                        FilledButton(
                            onClick = {
                                ctx.router.navigateTo(Navigation.Screen.ManageCompany().route)
                            },
                            modifier = Modifier.fillMaxWidth()
                        ) {
                            Row(
                                horizontalArrangement = Arrangement.Center,
                                verticalAlignment = Alignment.CenterVertically
                            ) {
                                DsMaterialSymbols(
                                    icon = "add",
                                    modifier = Modifier.size(20.px).margin(right = 8.px)
                                )
                                SpanText("Bedrijf toevoegen")
                            }
                        }

                        OutlinedButton(
                            onClick = {
                                ctx.router.navigateTo(Navigation.Screen.Home.route)
                            },
                            modifier = Modifier.fillMaxWidth()
                        ) {
                            SpanText("Terug naar home")
                        }
                    }
                } else {
                    // Horizontal layout for desktop
                    Row(
                        modifier = Modifier
                            .fillMaxWidth()
                            .margin(top = 8.px),
                        horizontalArrangement = Arrangement.Center,
                        verticalAlignment = Alignment.CenterVertically
                    ) {
                        OutlinedButton(
                            onClick = {
                                ctx.router.navigateTo(Navigation.Screen.Home.route)
                            }
                        ) {
                            SpanText("Terug naar home")
                        }

                        Box(modifier = Modifier.size(16.px))

                        FilledButton(
                            onClick = {
                                ctx.router.navigateTo(Navigation.Screen.ManageCompany().route)
                            }
                        ) {
                            Row(
                                horizontalArrangement = Arrangement.Center,
                                verticalAlignment = Alignment.CenterVertically
                            ) {
                                DsMaterialSymbols(
                                    icon = "add",
                                    modifier = Modifier.size(20.px).margin(right = 8.px)
                                )
                                SpanText("Bedrijf toevoegen")
                            }
                        }
                    }
                }
            }
        }
    }
}
